import React from "react"
import { graphql } from "gatsby"
import Layout from "../components/layouts/default-layout"
import AnnualEvents from "../components/news-events/annual-events"
import Container from "../components/bootstrap/container"
import Pagination from "../components/shared/pagination"
import Seo2 from "../components/shared/seo2"
import { AppendImage } from "../utils/utilities"

export default function AnnualEventsTemplate({ data }) {
  const thisYear = new Date().getFullYear()
  data.allDirectory.edges.forEach(element => {
    if (element.node.base > thisYear) {
      data.allDirectory.edges.pop()
    }
  })
  return (
    <Layout academicsMenu={false} newsMenu={true} studentMenu={false}>
      <div id="annual-events" className="bg-brown">
        <Container as="section" className="py-5">
          <h1 className="text-center text-light pt-4 pb-2">
            {data.directory.base}
            &nbsp;Events Archive
          </h1>
          <hr className="border-1 border-top border-lsu-dark-gold opacity-100" />
          <Pagination
            years={data.allDirectory.edges}
            year={data.directory.base}
            type="events"
          />
          <hr className="border-1 border-top border-lsu-dark-gold opacity-100" />
          {data.allMdx.edges.length > 0 && (
            <AnnualEvents data={data.allMdx.edges} faculty={data.faculty} />
          )}
          {data.allMdx.edges.length <= 0 && (
            <p className="text-light">
              No events have taken place this year yet
            </p>
          )}
        </Container>
      </div>
    </Layout>
  )
}

export function Head({ location, data }) {
  const image = AppendImage(data?.seoImage?.childImageSharp?.resize)
  const pathName = location.pathname
  const newsArticlessNumber = data.allMdx.edges.length
  const keywords = [
    "events",
    "lsu events",
    "digital media events",
    "louisiana state university",
    "lsu",
    "video game design courses",
    "lsu digital media center",
    "digital arts programs",
    "video game university",
    "digital media",
  ]
  return (
    <>
      <Seo2
        title={`${data.directory.base} Events Archive`}
        type="EventsList"
        ogType="website"
        image={image}
        keywrds={[keywords]}
        url={pathName}
        description={`All events from Louisiana State University (LSU), Digital Media Arts & Engineering (DMAE) program and from around the Baton Rouge and New Orleans area from ${data.directory.base}`}
        academicsMenu={false}
        newsMenu={true}
        studentMenu={false}
        numberofArticles={newsArticlessNumber}
        listOfArticles={data.allMdx.edges}
      />
    </>
  )
}

export const pageQuery = graphql`
  query EventsYear($base: String, $year: String) {
    directory(base: { eq: $base }) {
      id
      base
    }
    allMdx(
      filter: {
        internal: { contentFilePath: { regex: $year } }
        isFuture: { eq: false }
        frontmatter: { published: { ne: "draft" } }
      }
      sort: { frontmatter: { date: DESC } }
    ) {
      edges {
        node {
          id
          fields {
            slug
          }
          excerpt(pruneLength: 300)
          frontmatter {
            title
            date
            vimeo_video
            youtube_video
            author
            author_photo
            email
            job_position
            poster {
              childImageSharp {
                gatsbyImageData
                resize(width: 1200) {
                  src
                  width
                  height
                }
              }
            }
          }
        }
      }
    }
    allDirectory(
      filter: {
        sourceInstanceName: { eq: "posts" }
        relativeDirectory: { eq: "events" }
      }
      sort: { base: ASC }
    ) {
      edges {
        node {
          base
        }
      }
    }
    faculty: allFile(
      filter: {
        relativeDirectory: { eq: "faculty" }
        extension: { regex: "/(jpg)|(png)|(tif)|(tiff)|(webp)|(jpeg)/" }
      }
    ) {
      nodes {
        childImageSharp {
          gatsbyImageData(width: 50, height: 50, layout: FIXED)
          original {
            height
            width
          }
        }
        base
      }
    }
    seoImage: file(
      relativePath: { eq: "seo/LSU0032studentsinQuadrangleEvents.jpg" }
    ) {
      childImageSharp {
        gatsbyImageData(placeholder: BLURRED)
        resize(width: 1200) {
          height
          width
          src
        }
      }
    }
  }
`
